import React, { Component } from 'react'
import { connect } from 'react-redux'

import './hoverpopup.scss'

/**
 * How to use:
 * <HoverPopup
 *   UseClick={useClick} // Used to enable on click events
 *   UseHover={useHover} // Used to enable on mouse hover event
 *   orderId={item.Id} // Used to make the popup unique
 *   getVerticalScrollOffset={this.props.getVerticalScrollOffset} // Method used to getting the vertical scroll offset
 *   getHorizontalScrollOffset={this.props.getHorizontalScrollOffset} // Method used to getting the horizontal scroll offset
 *   scrollColumn={this.props.step} // number used if the page has multiple scroll containers like WorkScreen
 *   PopupContent={lines} > // Used to send content inside the popup
 *    <img src={imgPath + image} className='PaintBodyStatus' /> // Put the HoverPopup outside the area that should be affected by the click og hover event
 * </HoverPopup>
 */

class HoverPopup extends Component {

  constructor (props) {
    super(props)
    this.state = {
      show: false,
      isHovering: false,
      positionTop: undefined,
      positionLeft: undefined,
      positionBottom: undefined
    }
    this.togglePortal = this.togglePortal.bind(this)
    this.handleMouseHover = this.handleMouseHover.bind(this)
    this.handleMouseHoverEnter = this.handleMouseHoverEnter.bind(this)
    this.handleMouseHoverLeave = this.handleMouseHoverLeave.bind(this)
    this.handlePopupPosition = this.handlePopupPosition.bind(this)
  }

  togglePortal (e) {
    e.preventDefault()
    if (this.props.UseClick !== true) return null
    if (!this.state.show) {
      this.setState({
        show: true,
        positionTop: undefined,
        positionLeft: undefined,
        positionBottom: undefined
      }, () => {
        window.setTimeout(() => {
          window.addEventListener('click', this.togglePortal)
          this.handlePopupPosition()
        }, 10)
      })
    } else {
      window.removeEventListener('click', this.togglePortal)
      this.setState({
        show: false
      })
    }
  }

  handlePopupPosition () {
    let refName = 'child' + this.props.orderId
    let el = this.refs[refName]
    let bounds = el && el.getBoundingClientRect()
    let positionTop = this.state.positionTop
    let positionLeft = this.state.positionLeft
    let positionBottom = this.state.positionBottom
    let viewHeight = window.innerHeight
    if (bounds !== null) {
      positionTop = bounds.top
      positionLeft = bounds.left
      positionBottom = bounds.bottom
      if (this.props.getVerticalScrollOffset !== undefined) {
        let topOffset = this.props.getVerticalScrollOffset(this.props.scrollColumn)
        let outsideScreenPx = positionBottom - (viewHeight + topOffset)
        if (outsideScreenPx > 0) { // if below screen, set bottom position
          positionBottom = outsideScreenPx
          positionTop = undefined
        } else {
          positionTop = positionTop - topOffset
          positionBottom = undefined
        }
      }
      if (this.props.getHorizontalScrollOffset !== undefined) {
        let leftOffset = this.props.getHorizontalScrollOffset()
        positionLeft = positionLeft - leftOffset
      }
    }
    this.setState({
      positionTop: positionTop,
      positionLeft: positionLeft,
      positionBottom: positionBottom
    })
  }

  handleMouseHover (value) {
    if (this.props.UseHover !== true) return null
    let isHovering = this.state.isHovering
    if (value !== undefined) {
      isHovering = value
    }
    if (!isHovering) {
      this.setState({
        isHovering: true,
        positionTop: undefined,
        positionLeft: undefined,
        positionBottom: undefined
      }, () => {
        this.handlePopupPosition()
      })
    } else {
      this.setState({
        isHovering: false
      })
    }
  }

  handleMouseHoverEnter () {
    if (this.props.UseHover !== true) return null
    this.setState({
      isHovering: true,
      positionTop: undefined,
      positionLeft: undefined,
      positionBottom: undefined
    }, () => {
      this.handlePopupPosition()
    })
  }

  handleMouseHoverLeave () {
    if (this.props.UseHover !== true) return null
    this.setState({
      isHovering: false
    })
  }

  render () {
    let popupStyle = {}
    if (this.state.positionTop !== undefined) {
      popupStyle = {
        top: this.state.positionTop
      }
    }
    if (this.state.positionLeft !== undefined) {
      popupStyle = {
        ...popupStyle,
        left: this.state.positionLeft
      }
    }
    if (this.state.positionBottom !== undefined) {
      popupStyle = {
        ...popupStyle,
        bottom: this.state.positionBottom
      }
    }
    let hoverClass = 'hoverinfoclass'
    let customStyle = {}
    let refName = 'child' + this.props.orderId
    if (this.props.customStyle !== undefined) {
      hoverClass = ''
      customStyle = this.props.customStyle
    }
    return (
      <div className={hoverClass} style={customStyle} onClick={this.togglePortal} onMouseEnter={this.handleMouseHover.bind(this, false)} onMouseLeave={this.handleMouseHover.bind(this, true)}>
        {this.props.children}
        {(this.state.show || this.state.isHovering) && this.props.PopupContent !== undefined && (
          <div ref={refName} className={'hoverPopup'} style={popupStyle}>
            {this.props.PopupContent}
          </div>
        )}
      </div>
    )
  }

}

HoverPopup.defaultProps = {
  style: {}
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(HoverPopup)



// WEBPACK FOOTER //
// ./src/app/shared/components/HoverPopup/index.js